import { useRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { OptionsIcon } from '@/icons';
import DefaultOptionsMenu, {
  type DefaultOptionsMenuProps,
} from '@/components/DefaultOptionsMenu';
import { useToggle } from '@/hooks/useToggle';
import { classes } from './utils';

export { MenuOption, MenuDivider } from '@/components/DefaultOptionsMenu';

export type OptionsMenuProps = {
  className?: string;
  extraOptions?: DefaultOptionsMenuProps['extraOptions'];
  onEdit?: () => void;
  onDelete?: () => void;
};

export default function OptionsMenu({
  className,
  extraOptions,
  onEdit,
  onDelete,
}: OptionsMenuProps) {
  const menuToggleRef = useRef(null);
  const [isMenuOpen, toggleMenu] = useToggle(false);

  const handleEdit = () => {
    toggleMenu();
    onEdit!();
  };

  const handleDelete = () => {
    toggleMenu();
    onDelete!();
  };
  return (
    <div className={twMerge(classes.optionsWrapper, className)}>
      <OptionsIcon
        ref={menuToggleRef}
        className={classes.optionsIcon}
        onClick={() => toggleMenu()}
      />
      <DefaultOptionsMenu
        open={isMenuOpen}
        anchorTo={menuToggleRef.current}
        extraOptions={extraOptions}
        onEdit={onEdit ? handleEdit : undefined}
        onDelete={onDelete ? handleDelete : undefined}
        onClose={() => toggleMenu()}
      />
    </div>
  );
}
